import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
const StockPrimaryMarketBlock = (props) => {
    return (React.createElement(Row, { className: "mx-0 searchblock-generic-block primary-market-tab-section" },
        React.createElement(Col, { lg: 12, className: "d-space-between px-0" },
            React.createElement("div", null,
                React.createElement("span", { className: "DMSan_14_500 txt_blackOne1 d-flex" }, props.stockName),
                React.createElement("div", { className: "d-flex mgt-5" },
                    !!props.marketStats && (React.createElement("span", { className: "imCircle imcircle-custom green txt-green DMSansMedium_12_500" }, props.marketStats)),
                    React.createElement("span", { className: "DMSansNormal_12_400" },
                        "Closes on",
                        " ",
                        React.createElement("span", { className: "txt-bloodRed " }, props.marketClose)))),
            React.createElement("div", null, (props === null || props === void 0 ? void 0 : props.edit) ? (props === null || props === void 0 ? void 0 : props.editAction) : (React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", className: "small-edbutton-search pb-10-rem pt-10-rem px-29-rem", onClick: () => props.onApply() })))),
        !(props === null || props === void 0 ? void 0 : props.edit) && (React.createElement(Col, { lg: 12, className: "px-0 d-flex  mgt-10" },
            React.createElement("span", { className: "DMSansNormal_12_400 txt_secondary-gray" },
                "Subscription",
                " ",
                React.createElement("span", { className: "txt_bloodRed" },
                    props.subscriptionAmount,
                    " \u00A0",
                    " ")),
            React.createElement("span", { className: "DMSansNormal_12_400 txt_secondary-gray" },
                "as on ",
                props.closeTime,
                " ",
                React.createElement("span", { className: "imCircle" }, "Min Inv"),
                " ",
                React.createElement("span", { className: "txt_blackOne1" }, props.minInv && "Rs." + props.minInv))))));
};
export default StockPrimaryMarketBlock;
